export const csrfToken = () =>
  document.querySelector('meta[name=csrf-token]')?.getAttribute('content') ?? ''
export const csrfParam = () =>
  document.querySelector('meta[name=csrf-param]')?.getAttribute('content') ?? ''
